import { Controller } from "stimulus"
import sweet_alert from "../entrypoints/src/admin/utilities/sweet_alert";
import FrequencyValueService from "../entrypoints/src/admin/services/frequency-value-service";

export default class extends Controller {
  static targets = [ 'emptyMessage', 'container', 'updateValues' ];
  static values = { valuesSize: Number };

  connect() {
    this.updateEmptyMessage();
    this.element.querySelector('a.add-row').addEventListener('add-row:appended', () => this.valuesSizeValue += 1);
  }

  removeValue(ev) {
    let $row = ev.currentTarget.closest('.row'),
      inputName = $row.dataset.inputName;
    this.askConfirmation().then((result) => {
      if (result.value) {
        this.containerTarget.insertAdjacentHTML('beforeend', `<input type="hidden" name="${inputName}[_destroy]" value="1" />`);
        this.containerTarget.insertAdjacentHTML('beforeend', `<input type="hidden" name="${inputName}[id]" value="${$row.dataset.id}" />`);
        $row.remove();
        this.valuesSizeValue -= 1;
        return;
      }
    })
  }

  changeValue(ev) {
    let input = ev.target;
    if (input.nodeName !== 'INPUT' || ! input.dataset.valueId)
      return;
  }

  updateValues(ev) {
    let element = ev.target,
      input = this.element.querySelector(`input[data-value-id="${element.dataset.valueId}"]`);

    if (!input)
      return sweet_alert.fire('Espera!', 'Referência inválida', 'error');

    sweet_alert.fire({
      customClass: {
        cancelButton: 'btn btn-gray-primary mx-2',
        confirmButton: 'btn btn-green-500 mx-2'
      },
      title: 'Atenção',
      html: "Tem certeza que deseja atualizar todos os contratos relacionados a essa frequência? <br><br> <strong>Nota:</strong> Todas as faturas em aberto serão atualizadas.",
      type: 'warning',
      animation: false,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, atualizar contratos e faturas'
    }).then(async (result) => {
      if (result.value) {
        try {
          let response = await FrequencyValueService.updateValues(element.dataset.valueId, { value: input.value }),
            key = Object.keys(response)[0];

          if (['info', 'error'].includes(key)) {
            return sweet_alert.fire('Atenção', response[key], key);
          }

          sweet_alert.fire({
            title: 'Contratos Atualizados',
            html: `
              <p class="text-left">Todos os <b>${response.length}</b> contratos abaixo foram atualizados com sucesso:</p>

              <div class="overflow-auto" style="height: 60vh">
                <table class="table table-striped table-sticky">
                  <thead>
                    <tr>
                      <th class="bg-white">#</th>
                      <th class="bg-white">Aluno</th>
                      <th class="bg-white">Contrato</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${response.map((contract) => `
                      <tr>
                        <td>${contract.id}</td>
                        <td><a href="/admin/enrollments/${contract.enrollment_id}" class="font-capitalize" data-turbo="false" target="_blank">${contract.student.toLowerCase()}</a></td>
                        <td class="font-capitalize">${contract.name.toLowerCase()}</td>
                      </tr>
                    `).join('')}
                  </tbody>
                </table>
              </div>
            `,
            width: '90vw',
            heightAuto: false,
            type: 'success',
            animation: true,
            showCancelButton: false,
            confirmBUttonText: 'Ok!'
          });

          element.classList.toggle('hidden', true);
        } catch (ex) {
          console.log(ex)
          sweet_alert.fire('Espera!', 'Não foi possível atualizar os contratos relacionados', 'error');
        }
      }
    });
  }

  askConfirmation() {
    return sweet_alert.fire({
      title: 'Atenção',
      customClass: {
        cancelButton: 'btn btn-gray-primary mx-2',
        confirmButton: 'btn btn-danger mx-2'
      },
      buttonsStyling: false,
      text: "Tem certeza que deseja realmente remover esse valor?",
      type: 'warning',
      animation: false,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, tenho certeza'
    });
  }

  valuesSizeValueChanged() {
    this.updateEmptyMessage();
  }

  updateEmptyMessage() {
    this.emptyMessageTarget.classList.toggle('hidden', this.valuesSizeValue > 0);
    this.containerTarget.classList.toggle('hidden', this.valuesSizeValue == 0);
  }
}